import './icon.css';
export default {
  "icon": "pf-v6-c-icon",
  "iconContent": "pf-v6-c-icon__content",
  "iconProgress": "pf-v6-c-icon__progress",
  "modifiers": {
    "inline": "pf-m-inline",
    "sm": "pf-m-sm",
    "md": "pf-m-md",
    "lg": "pf-m-lg",
    "xl": "pf-m-xl",
    "2xl": "pf-m-2xl",
    "3xl": "pf-m-3xl",
    "bodySm": "pf-m-body-sm",
    "bodyDefault": "pf-m-body-default",
    "bodyLg": "pf-m-body-lg",
    "headingSm": "pf-m-heading-sm",
    "headingMd": "pf-m-heading-md",
    "headingLg": "pf-m-heading-lg",
    "headingXl": "pf-m-heading-xl",
    "heading_2xl": "pf-m-heading-2xl",
    "heading_3xl": "pf-m-heading-3xl",
    "inProgress": "pf-m-in-progress",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "info": "pf-m-info",
    "custom": "pf-m-custom"
  },
  "spinner": "pf-v6-c-spinner"
};